import React from 'react';
import './LoadingDots.css';

const LoadingDots = () => {
  return (
    <span className="loading-dots">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  );
};

export default LoadingDots;
